import React from 'react';

export default function IndexSectionFeatures6() {
    return (
        <React.Fragment>
            <>
                <section id={'about'} className="py-20">
                    <div className="container mx-auto px-4">
                        <div className="flex flex-wrap -m-4">
                            <div className="w-full lg:w-1/2 p-4">
                                <div className="inline-block bg-yellow-500 px-2 py-1 text-xs font-bold mb-6">Features
                                </div>
                                <h1 className="font-heading text-4xl font-bold mb-6 max-w-sm">A search engine for food.</h1>
                                <p className="text-gray-500 max-w-md">No more going over hundreds of different websites,
                                    apps, and checking several sources to find a place to eat, we'll find you the best
                                    place to eat in one tap!
                                </p>
                            </div>
                            <div className="w-full lg:w-1/2 p-4">
                                <div className="flex flex-wrap -m-4">
                                    <div className="w-full lg:w-1/2 p-4">
            <span className="mb-6 block">
              <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48" fill="none">
                <path d="M14 40H40" stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8 40V34L34 8L40 14L14 40H8Z" stroke="#006251" strokeWidth={2} strokeLinecap="round"
                      strokeLinejoin="round"/>
                <path d="M34 20L28 14" stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
                                        <h2 className="text-xl mb-4">The most complete food app
                                        </h2>
                                        <p className="text-gray-500 max-w-xs">We compile data from all over the web to
                                            provide you with the most complete information on restaurants</p>
                                    </div>
                                    <div className="w-full lg:w-1/2 p-4">
            <span className="mb-6 block">
              <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48" fill="none">
                <path d="M8 14L24 6L40 14V34L24 42L8 34V14Z" stroke="#006251" strokeWidth={2} strokeLinecap="round"
                      strokeLinejoin="round"/>
                <path d="M30 18L18 30" stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M18 18L30 30" stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
                                        <h2 className="text-xl mb-4">Wherever you are
                                        </h2>
                                        <p className="text-gray-500 max-w-xs">FindAMeal uses your location to find the
                                            best matches while you are on the go</p>
                                    </div>
                                    <div className="w-full lg:w-1/2 p-4">
            <span className="mb-6 block">
              <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48" fill="none">
                <path d="M24 44C24 44 40 36 40 24V10L24 4L8 10V24C8 36 24 44 24 44Z" stroke="#006251" strokeWidth={2}
                      strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16 23L22 29L34 17" stroke="#006251" strokeWidth={2} strokeLinecap="round"
                      strokeLinejoin="round"/>
              </svg>    
            </span>
                                        <h2 className="text-xl mb-4">Share your best tips
                                        </h2>
                                        <p className="text-gray-500 max-w-xs">Create lists with your favorite
                                            restaurants and share it with friends!</p>
                                    </div>
                                    <div className="w-full lg:w-1/2 p-4">
            <span className="mb-6 block">
              <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48" fill="none">
                <path
                    d="M24 30C27.866 30 31 26.866 31 23C31 19.134 27.866 16 24 16C20.134 16 17 19.134 17 23C17 26.866 20.134 30 24 30Z"
                    stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
                <path
                    d="M42 23.9999C42.006 28.6858 40.1784 33.1881 36.908 36.5439C35.2324 38.2727 33.2261 39.6466 31.0086 40.5839C28.791 41.5213 26.4075 42.0028 24 41.9999C21.5925 42.0028 19.209 41.5213 16.9914 40.5839C14.7739 39.6466 12.7676 38.2727 11.092 36.5439C9.03644 34.4289 7.53208 31.8412 6.71122 29.0085C5.89036 26.1757 5.77815 23.1846 6.38447 20.2982C6.99079 17.4119 8.29705 14.7188 10.1884 12.4557C12.0797 10.1927 14.4981 8.42905 17.2309 7.31994C19.9638 6.21082 22.9273 5.79021 25.8608 6.0951C28.7943 6.39999 31.608 7.42105 34.0543 9.06846C36.5006 10.7159 38.5047 12.9392 39.8902 15.5428C41.2757 18.1464 42.0002 21.0506 42 23.9999V23.9999Z"
                    stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
                <path
                    d="M11.092 36.544C12.5768 34.5144 14.5197 32.8639 16.7626 31.7268C19.0056 30.5897 21.4853 29.9981 24 30C26.5147 29.9981 28.9944 30.5897 31.2374 31.7268C33.4803 32.8639 35.4232 34.5144 36.908 36.544"
                    stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
                                        <h2 className="text-xl mb-4">Discover your city
                                        </h2>
                                        <p className="text-gray-500 max-w-xs">Get recommendations for new places and
                                            hidden gems in your area
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


            </>
        </React.Fragment>
    );
}

